import styled from 'styled-components'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import { Theme } from 'features/ui/types'
import { AutomationId, AUTO_ATTR_KEY } from 'utils/automationUtil'

export const StyledSortingContainer = styled.div.attrs({
  [AUTO_ATTR_KEY]: AutomationId.insightModal.insightContent.soundbite.sortByContainer
})`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 0;
`
interface StyledWarningMessageProps {
  mode: Theme
  noBorder?: boolean
}

export const StyledWarningMessage = styled.div.attrs({
  [AUTO_ATTR_KEY]: AutomationId.insightModal.insightContent.soundbite.warningMessage
})<StyledWarningMessageProps>`
  border-top: 1px solid
    ${({ mode, noBorder }) => (noBorder ? 'none' : sys[mode].common.divider[100])};
  display: flex;
  align-items: center;
  padding: 8px 16px;
  margin: 0 -16px;
`
